import { combineReducers } from 'redux'

import auth from './auth.reducer'
import redirect from './redirect.reducer'
import ui from './ui.reducer'
import organization from './organization.reducer'
import account from './account.reducer'
import audience from './audience.reducer'
import campaign from './campaign.reducer'
import template from './template.reducer'
import stats from './stats.reducer'

const rootReducer = combineReducers({
  auth,
  ui,
  redirect,
  organization,
  account,
  audience,
  campaign,
  template,
  stats
})

export default rootReducer
